import React from 'react';
import './Submenu.css';

interface SubMenuProps {
    menuItems: string[];
    selectedItem: string;
    hoveredItem: string;
    setSelectedItem: (item: string) => void;
    setHoveredItem: (item: string) => void;
}

export const SubMenu: React.FC<SubMenuProps> = ({ menuItems, selectedItem, hoveredItem, setSelectedItem, setHoveredItem }) => {
    return (
        <div className="submenu">
            {menuItems.map((item) => (
                <button
                    key={item}
                    className={`submenu-item ${selectedItem === item && hoveredItem !== "" && hoveredItem !== item ? 'hovered-active' : selectedItem === item ? 'active' : hoveredItem === item ? 'hovered' : ''}`}
                    onClick={() => setSelectedItem(item)}
                    onMouseEnter={() => setHoveredItem(item)}
                    onMouseLeave={() => setHoveredItem('')}
                    aria-pressed={selectedItem === item}
                >
                    {item}
                </button>
            ))}
        </div>
    );
};
